import PaywallModal from './paywall.modal'

export default PaywallModal
